import React, { useContext } from "react"

import { Markdown, H1 } from "~components/Markdown"
import { Source } from "~layouts/PageLayout"

import { MarkdownDataProvider } from "~contexts/MarkdownDataContext"
import MicrocopyContext from "~contexts/MicrocopyContext"
import * as style from "./Page.module.scss"

import QuickStartProgress from "./QuickStartProgress"
import RelatedPages from "./RelatedPages"

const Page = ({
  page,
  hideTitle = false,
  hideSource = false,
  hideLinks = false,
  setDisplaySidebar,
}) => {
  const microcopy = useContext(MicrocopyContext)

  return (
    <div className={style.page} data-hide-title={hideTitle}>
      <MarkdownDataProvider data={page}>
        <H1>{page.title}</H1>
        {!hideSource && (
          <Source page={page} setDisplaySidebar={setDisplaySidebar} />
        )}
        <RelatedPages
          pages={page.requiredGuides}
          title={microcopy.text("guides.titles.required_guides")}
          divider
        />
        {page.type === "quick-start" && page.stepNumber > 0 && (
          <QuickStartProgress page={page} />
        )}
        <Markdown ast={page.htmlAst} />
        {!hideLinks && (
          <div className={style.relatedPages}>
            <div>
              <RelatedPages
                endpoints={page.relatedEndpoints}
                title={microcopy.text("guides.titles.api_endpoints")}
              />
              <RelatedPages
                pages={page.relatedGuides}
                title={microcopy.text("guides.titles.related_guides")}
              />
            </div>
          </div>
        )}
      </MarkdownDataProvider>
    </div>
  )
}

export default Page
